import type { FaireProductEntity } from "../../entity_types/product";

export const p_bw94td7rmq: FaireProductEntity = {
  token: "p_bw94td7rmq",
  type: "product",
  name: "Baby/ Toddler Beanie with Fur Pom Pom- Cream",
  brandToken: "b_6d9w5m3rqy",
  brandName: "land of petite",
  imageUrl:
    "https://cdn.faire.com/fastly/f3abf527251f9c7852f60c2797b69aceb5cc2b546283034d13c5c394e5f4763a.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.02,
  description:
    "Keep your little one cozy and stylish with this adorable knit beanie, topped with a playful fur pom pom. The perfect accessory for chilly fall and winter days.\n\nSizes: Baby & toddler fit\n\nColors: Black, Cream, Light Pink\n\nStyle: Soft knit design with faux fur pom pom accent\n\nA must-have cold-weather essential that adds both warmth and charm to any outfit.",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:25.503Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
